// Admin e Exxer usam as telas do coordenador sempre em nome de um coordenador
// escolhido (backend: middlewares/comoCoordenador.js). A escolha fica na aba do
// navegador (sessionStorage) e vai no cabecalho X-Coordenador-Id, mas so nas
// telas de coordenacao: nas telas de admin (que tambem usam /escolas e
// /usuarios) o admin continua vendo tudo.

const CHAVE = 'coordenadorAtuacao';

export const ROTAS_DE_COORDENACAO = [
  '/coordenador/turmas',
  '/coordenador/vincular-alunos',
  '/coordenador/vincular-professores'
];

export const ehRotaDeCoordenacao = (caminho) => ROTAS_DE_COORDENACAO.some((r) => String(caminho || '').startsWith(r));

export const lerCoordenadorEscolhido = () => {
  try {
    const valor = JSON.parse(sessionStorage.getItem(CHAVE) || 'null');
    return valor && Number(valor.id) > 0 ? valor : null;
  } catch {
    return null;
  }
};

export const salvarCoordenadorEscolhido = (coordenador) => {
  try {
    if (coordenador) sessionStorage.setItem(CHAVE, JSON.stringify({ id: coordenador.id, nome: coordenador.nome }));
    else sessionStorage.removeItem(CHAVE);
  } catch {
    // Sem sessionStorage a escolha vale so enquanto a tela estiver aberta.
  }
};

// Usado pelo interceptor do api.js. `semCoordenador: true` na chamada pula o
// cabecalho (ex.: a lista de coordenadores do proprio seletor).
export const cabecalhoDoCoordenador = (config, caminho) => {
  if (config?.semCoordenador || !ehRotaDeCoordenacao(caminho)) return null;
  const escolhido = lerCoordenadorEscolhido();
  return escolhido ? String(escolhido.id) : null;
};
